import { useWatchOrganizationStatusSubscription } from "~@/graphql/codegen/generated";

// Хук для подписки на статус организации
const useWatchOrganizationStatus = (oid: string) => {
  // Подписка на изменения статуса организации
  useWatchOrganizationStatusSubscription({
    variables: { oid }, // Передаем идентификатор организации
    skip: !oid, // Пропускаем подписку, если нет идентификатора организации
    onData({ data: status, client: { cache } }) {
      const statusData = status.data?.watchOrganizationStatus; // Получаем данные статуса организации из подписки

      // Модификация кэша для обновления статуса организации
      cache.modify({
        id: cache.identify({
          id: oid, // Идентификатор организации
          __typename: "Organization", // Тип объекта в кэше
        }),
        fields: {
          status: () => {
            return statusData; // Обновляем статус в кэше новыми данными
          },
        },
      });
    },
  });
};

export default useWatchOrganizationStatus;
